import React, { useEffect } from 'react';
import AboutHero from '../innovher/AboutHero';
import About from '../innovher/About';
import Team from '../innovher/Team';

import SEO from '../SEO';

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="min-h-screen bg-[#08080a] text-white">
      <SEO
        title="About InnovHer"
        description="Alongside every enduring enterprise is a deliberate journey of creation. Born in Jaipur, InnovHer is a venture-building ecosystem helping ambitious ideas become stronger, scalable businesses."
        keywords="about InnovHer, venture builder Jaipur, InnovHer team, InnovACE, InnovVentures, Studio-I"
      />
      <AboutHero />
      <About />
      {/* <Team /> */}
    </div>
  );
}
